import React from 'react';
import { Check } from 'lucide-react';
import { getQuestion } from './scoring';
import { useScore } from './ScoreContext';
interface ReaderPathCheckProps {
  questionId: string;
  checkLabel?: string;
  confirmationText?: string;
}
export function ReaderPathCheck({
  questionId,
  checkLabel = 'Quick Check',
  confirmationText = 'Saved. This is part of your score.'
}: ReaderPathCheckProps) {
  const {
    answers,
    setAnswer
  } = useScore();
  const question = getQuestion(questionId);
  if (!question) return null;
  const selectedScore = answers[questionId];
  return <div className="relative my-16 w-full overflow-hidden rounded-3xl border border-gray-200/70 bg-paper-dark p-6 shadow-[inset_0_2px_16px_rgba(26,40,56,0.05)] sm:p-8 md:p-12" data-id="element-439">
      <div className="absolute bottom-6 left-0 top-6 w-1 rounded-r-full bg-seaglass md:w-1.5" data-id="element-440" />
      <div className="pl-4 md:pl-6" data-id="element-441">
        <div className="mb-5 flex items-center gap-2.5" data-id="element-442">
          <div className="h-2 w-2 rounded-full bg-seaglass" data-id="element-443" />
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-seaglass" data-id="element-444">
            {checkLabel}
          </span>
        </div>

        <h3 className="mb-8 max-w-2xl font-serif text-2xl leading-snug text-navy md:mb-10 md:text-[2rem]" data-id="element-445">
          {question.prompt}
        </h3>

        <div className="flex flex-col gap-3" data-id="element-446">
          {question.options.map(option => {
          const isSelected = selectedScore === option.score;
          return <button key={option.letter} type="button" onClick={() => setAnswer(questionId, option.score)} aria-pressed={isSelected} className={`flex min-h-[64px] w-full items-start gap-4 rounded-2xl border p-5 text-left transition-all duration-200 md:gap-5 md:p-6 ${isSelected ? 'border-seaglass bg-seaglass/10 ring-1 ring-seaglass/40' : 'border-gray-200 bg-white hover:border-seaglass/50'}`} data-id="element-447">
                <span className={`mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full border md:h-7 md:w-7 ${isSelected ? 'border-seaglass bg-seaglass text-white' : 'border-gray-300 bg-white text-transparent'}`} data-id="element-448">
                  <Check className="h-3.5 w-3.5" strokeWidth={3} data-id="element-449" />
                </span>
                <span className="flex-1 leading-relaxed text-text" data-id="element-450">
                  <strong className="mr-2.5 font-serif text-lg font-semibold text-navy" data-id="element-451">
                    {option.letter}.
                  </strong>
                  {option.text}
                </span>
              </button>;
        })}
        </div>

        {selectedScore !== undefined && <div className="mt-6 flex items-center gap-2.5 text-sm font-medium text-seaglass" data-id="element-452">
            <Check className="h-4 w-4" strokeWidth={2.5} data-id="element-453" />
            <span data-id="element-454">{confirmationText}</span>
          </div>}
      </div>
    </div>;
}